import { useEffect, useState } from "react";
import { getListSheet, getListSheetDetail } from "../api";

export const useListSheet = (params) => {
  const [data, setData] = useState([]);
  async function fetchData() {
    const response = await getListSheet({ ...params });
    if (response.data.status) setData(response.data.data?.data);
  }
  useEffect(() => {
    fetchData();
  }, [JSON.stringify(params)]);
  return data;
};

export const useCountListSheet = (params) => {
  const [data, setData] = useState(null);
  async function fetchData() {
    const response = await getListSheet({ ...params });
    if (response.data.status) setData(response.data.data?.total);
  }
  useEffect(() => {
    fetchData();
  }, [JSON.stringify(params)]);
  return data;
};
export const useListSheetDetail = (params) => {
  const [data, setData] = useState([]);
  async function fetchData() {
    const response = await getListSheetDetail({ ...params });
    if (response.data.status) setData(response.data.data?.data);
  }
  useEffect(() => {
    fetchData();
  }, [JSON.stringify(params)]);
  return data;
};

export const useCountListSheetDetail = (params) => {
  const [data, setData] = useState(null);
  async function fetchData() {
    const response = await getListSheetDetail({ ...params });
    if (response.data.status) setData(response.data.data?.total);
  }
  useEffect(() => {
    fetchData();
  }, [JSON.stringify(params)]);
  return data;
};
